import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const USERNAME_SCHEMA_FIELD_NAMES = {
  USERNAME: "username",
};
export const USERNAME_MAX_LENGTH = 20;
export const USERNAME_MIN_LENGTH = 4;

const USERNAME_REGEX = /^[a-zA-Z\d#&!@$%^*(){}[\]:;"'<>,.?/~`+-_=]*$/;
const USERNAME_MUST_CONTAIN_ALPHA_REGEX = /[a-zA-Z]+/;

export const getUsernameFormFieldSchema = () =>
  yup
    .string()
    .trim()
    .required()
    .max(USERNAME_MAX_LENGTH)
    .min(USERNAME_MIN_LENGTH)
    .matches(USERNAME_REGEX)
    .matches(
      USERNAME_MUST_CONTAIN_ALPHA_REGEX,
      i18n("UsernameFormField__TEXT_USERNAME_REQUIRES_ALPHA")
    )
    .label(i18n("UsernameFormField__LABEL").toLowerCase());
